import LayoutCarousel from './LayoutCarousel';

export default LayoutCarousel;
